export default __webpack_public_path__ + "static/media/cookie-policy.1f6a2f45.svg";